fragment InboxRelatedLeadStageEdgeFragment on LeadStagesEdge {
    node {
        id
        name
    }
    isActive
}
